import styled from 'styled-components';

export const FooterDot = styled.span`
  color: ${({ theme }) => theme.colors.black25};
`;

export const PrivacyLink = styled.a`
  color: ${({ theme }) => theme.colors.blue100};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
